module.exports = __webpack_public_path__ + "img/18.2240c3e4.png";